<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-text-field
            v-model="item.name"
            :label="$t('global.name')"
            type="text"
        />
      </v-col>
      <v-col cols="12" sm="6" md="6">
        <v-text-field
            v-model="item.ref"
            :label="$t('designfile.ref')"
            type="text"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
            v-model="item.type"
            :items="typeSelectItems"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            :label="$t('designfile.type')"
            item-text="name"
            item-value="@id"
        />
      </v-col>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
            v-model="item.tags"
            :items="tagSelectItems"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            :label="$t('designfile.tags')"
            item-text="name"
            item-value="@id"
            color="primary"
            chips

        >
          <template v-slot:selection="{ attrs, item, parent, selected }">
            <v-chip
                v-if="item === Object(item)"
                v-bind="attrs"
                color="primary"
                :input-value="selected"
                label
            >
              <span class="pr-2">
                {{ item.name }}
              </span>
            </v-chip>
          </template>
        </v-combobox>
      </v-col>
    </v-row>
    <v-row>

      <v-col cols="12" sm="6" md="6">
        <v-combobox
            v-model="item.customer"
            :items="customerSelectItems"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            :label="$t('designfile.customer')"
            item-text="name"
            item-value="@id"
        />
      </v-col>

      <v-col cols="12" sm="6" md="6">
        <v-combobox
            v-model="item.createdBy"
            :items="createdBySelectItems"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            :label="$t('global.createdby')"
            item-text="login"
            item-value="@id"
        />
      </v-col>
    </v-row>
    <v-row>
      <h3>{{ $t('global.createdat') }}</h3>
    </v-row>
    <v-row>

      <v-col cols="12" sm="6" md="6">
        <InputDate
            v-model="item.created_after"
            :label="$t('global.datestart')"
        />
      </v-col>

      <v-col cols="12" sm="6" md="6">
        <InputDate
            v-model="item.created_before"
            :label="$t('global.dateend')"
        />
      </v-col>

    </v-row>
    <v-row>
      <h3>{{ $t('global.updatedat') }}</h3>
    </v-row>
    <v-row>

      <v-col cols="12" sm="6" md="6">
        <InputDate
            v-model="item.updated_after"
            :label="$t('global.datestart')"
        />
      </v-col>

      <v-col cols="12" sm="6" md="6">
        <InputDate
            v-model="item.updated_before"
            :label="$t('global.dateend')"
        />
      </v-col>

    </v-row>
  </v-container>
</template>

<script>
import InputDate from '../InputDate';
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
export default {
  name: 'DesignFileFilter',
  components: {
    InputDate,
  },
  props: {
    values: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
    };
  },
  mounted() {
    this.customerGetSelectItems();
    this.createdByGetSelectItems();
    this.typeGetSelectItems();
    this.tagGetSelectItems();
  },

  computed: {
    ...mapFields('designfiletype', {
      typeSelectItems: 'selectItems',
    }),
    ...mapFields('customer', {
      customerSelectItems: 'selectItems',
    }),
    ...mapFields('user', {
      createdBySelectItems: 'selectItems',
    }),
    ...mapFields('tag', {
      tagSelectItems: 'selectItems',
    }),
    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    }
  },
  methods: {
    ...mapActions({
      typeGetSelectItems: 'designfiletype/fetchSelectItems',
      customerGetSelectItems: 'customer/fetchSelectItems',
      tagGetSelectItems: 'tag/fetchSelectItems',
      createdByGetSelectItems: 'user/fetchSelectItems',
    }),
  }
};
</script>
